/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createE } from '../../factoriesAny.js';
export var eDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createE: createE
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesE.generated.js
// module id = 496
// module chunks = 0